import {Typography} from "@leap4/frontend";
import * as _ from "lodash";
import {ScrapingUtils} from "../../utils/scraping.utils";
import React from "react";

export const renderValue = (value, key) => {
    return <Typography variant="h6" fontFamily={""} gutterBottom>
        {!_.isNil(value) ? ScrapingUtils.addSignsToMetricValue(key, value) : "NONE"} </Typography>
}